import React from "react";

interface FullPageLayoutProps {
  children: React.ReactNode;
}

/**
 * `h-[100dvh]` rather than `h-screen` (`100vh`): on a mobile browser `100vh` is
 * the LARGE viewport — the height the page would have with the URL bar hidden —
 * so a `100vh` container is taller than what is actually on screen while the bar
 * is showing. That left a dead strip under the page and made the whole thing
 * scroll by the difference, which pushed fixed headers up under the status bar.
 * `dvh` tracks the viewport that is really visible. Identical to `100vh` on
 * desktop and whenever the mobile chrome is hidden.
 */
const FullPageLayout: React.FC<FullPageLayoutProps> = ({ children }) => {
  return (
    <div className="flex h-viewport overflow-hidden">
      <div className="flex-1 overflow-y-auto">{children}</div>
    </div>
  );
};

export default FullPageLayout;
